export default __webpack_public_path__ + "static/media/bu-mala.9803f808.png";